import HelpLegal from "./Help.vue"
export default HelpLegal